import classNames from "../../../utils/classNames"
import formatDateTime from './../../../utils/formatDateTime';
import { DateTime } from 'luxon';

export const DateTimeInput = ({ label, register, registerName, watch, setValue, disabled = false, min = "" }) => {

  const dateTimeValue = watch(registerName);

  return (
    <div className="sm:col-span-1">
      <label className="text-sm font-medium text-gray-500">
        {label}
      </label>
      <input
        {...register(registerName)}
        value={dateTimeValue}
        onChange={(e) => setValue(registerName, e.target.value)}
        disabled={disabled}
        type="datetime-local"
        min={min}
        className={classNames(disabled ? "bg-gray-300" : "", "w-full mt-1 text-sm text-gray-900 border-1 border-gray-400")}
      />
    </div>
  )
}